import { stringify } from 'qs';
import request from '../../utils/request';

export async function execute(params) {
  return request(`/api/tscloud-eq-interact/interactbusiness/execute`, {
    // method: 'listEquipments',
    method: 'POST',
    body: params,
  });
}

// export async function getStreamIds(params) {
//   return request(`/api/blade-mbs/stream/connection-info?${stringify(params)}`);
// }

export async function getDetail(params) {
  return request(`/api/tscloud-eq-interact/conference/page?${stringify(params)}`);
}
